import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { loginRedirectState } from "@/utils/auth";

/**
 * Returns a navigator that bounces unauthenticated users to the login
 * screen (carrying the current location as the post-login redirect target)
 * instead of the requested destination. Used by the mobile nav components
 * whose destinations are auth-gated.
 */
export function useProtectedNavigate() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (to: string, requiresAuth = false) => {
    if (requiresAuth && !user) {
      navigate("/login", { state: loginRedirectState(location) });
      return;
    }
    navigate(to);
  };
}
